import React, { useState, useEffect } from 'react';
import { Plus, Trash2 } from 'lucide-react';

const BrainstormingGame = ({ config, onEnd, currentTheme }) => {
    const [theme, setTheme] = useState("");
    const [words, setWords] = useState([]);
    const [input, setInput] = useState("");

    useEffect(() => {
        if (config && config.themes) {
            const randomTheme = config.themes[Math.floor(Math.random() * config.themes.length)];
            setTheme(randomTheme);
        }
    }, [config]);

    const addWord = (e) => {
        e.preventDefault();
        if (input.trim()) {
            setWords([...words, input.trim()]);
            setInput("");
        }
    };

    return (
        <div className="brainstorm-container">
            <h3 className="brainstorm-subtitle">Thème du souvenir commun :</h3>
            <h1 className="brainstorm-theme-title">
                {theme}
            </h1>

            <div className="brainstorm-word-cloud">
                {words.length === 0 && <span className="cloud-placeholder">Quels mots vous viennent à l'esprit ?</span>}

                {words.map((word, idx) => (
                    <div key={idx} className="brainstorm-word-tag" style={{ backgroundColor: `hsla(${idx * 137.5}, 70%, 90%, 0.8)` }}>
                        {word}
                        <button onClick={() => setWords(words.filter((_, i) => i !== idx))} className="btn-delete-word">
                            <Trash2 size={20} />
                        </button>
                    </div>
                ))}
            </div>

            <form onSubmit={addWord} className="brainstorm-form">
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Mot-clé..."
                    className="brainstorm-input"
                />
                <button type="submit" className="btn-add-word">
                    <Plus /> Ajouter
                </button>
            </form>

            <div className="brainstorm-footer">
                <button onClick={() => window.location.reload()} className="btn-change-theme">Changer de thème</button>
            </div>
        </div>
    );
};

export default BrainstormingGame;